<template>
  <div>
    <a v-if="!payload.is_modal" @click="toggleVisibility" class="button is-danger">{{visibility_text}} {{ payload.designator }} Filters</a>
    <div v-if="show_filters">
      <a @click="submit()" class="filter button is-info mx-0">Submit Filters</a>
      <a @click="clearFilter()" class="filter button is-danger">Clear Filters</a>
      <a @click="selectAll()" class="filter button is-warning">Select All</a>
      <input v-if="payload.searchable" type="text" class="input mb-5" v-model="search" placeholder="Search ..." />
      <div class="vertical_space"></div>
      <div v-if="payload.grouped">
        <div v-for="(option, category) in showOptionsGrouped" :key="category">
          <p><b>{{category}}</b></p>
          <div class="is-flex is-align-items-center is-flex-wrap-wrap">
            <div v-for="skill in getSorted(option)" :key="skill.value">
              <a
                @click="toggleOption(skill)"
                :class="{'is-outlined': !isOptionSelected(skill) }"
                class="filter button is-primary has-text-black-bis"
              >
                {{ skill.text }}
              </a>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
      <a
        v-else
        @click="toggleOption(option)"
        v-for="option in showOptions"
        :key="option.value"
        :class="{'is-outlined': !isOptionSelected(option) }"
        class="filter button is-primary has-text-black-bis"
      >
        {{ option.text }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'multiple-filter',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      search: '',
      options: [],
      selected_options: undefined,
      show_filters: false
    }
  },
  computed: {
    visibility_text () {
      if (this.payload.is_modal) return true
      return this.show_filters ? 'Hide' : 'Show'
    },
    getSelectedOptions () {
      return this.selected_options.filter(option_value => option_value != '')
    },
    showOptions () {
      return this.payload.options.filter(o => o.text.toLowerCase().includes(this.search))
    },
    showOptionsGrouped () {
      const options = this.payload.options.filter(
        o => o.text.toLowerCase().includes(this.search)
      )
      const groupedObject = this.groupBy(options, this.payload.grouped)
      const ordered = {}
      if (groupedObject['Selected items']) {
        ordered['Selected items'] = groupedObject['Selected items']
        delete groupedObject['Selected items']
      }
      Object.keys(groupedObject).forEach(key => {
        ordered[key] = groupedObject[key]
      })

      return ordered
    }
  },
  created () {
    if (this.payload.is_modal) {
      this.show_filters = true
    }
    this.init()
  },
  methods: {
    init () {
      this.selected_options = (this.$route.query[this.payload.designator] || '').split(this.payload.splitter || ',')
      console.log(this.selected_options)
      if (this.payload.grouped) {
        this.options = this.groupBy(this.payload.options, this.payload.grouped)
      } else {
        this.options = this.payload.options
      }
    },
    groupBy (array, element) {
      const target = Object.create(null)
      array.forEach(el => {
        let key = el[element]
        if (this.isOptionSelected(el)) {
          key = 'Selected items'
        }
        if (key in target) target[key].push(el)
        else target[key] = [el]
      })
      return target
    },
    getSorted (array) {
      return [...array].sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
    },
    toggleVisibility () {
      this.show_filters = !this.show_filters
    },
    isOptionSelected (option) {
      return this.selected_options.includes(option.value)
    },
    toggleOption (option) {
      let filter_selected_options = this.getSelectedOptions
      if (filter_selected_options.includes(option.value)) {
        this.unselectOption(option)
        return
      }
      this.selectOption(option)
    },
    selectOption (option) {
      let filter_selected_options = this.getSelectedOptions
      filter_selected_options.push(option.value)
      this.selected_options = filter_selected_options
      this.$forceUpdate()
    },
    unselectOption (option_to_remove) {
      let filtered_options_array = this.getSelectedOptions.filter(filter_option_value => filter_option_value != option_to_remove.value)
      this.selected_options = filtered_options_array
      this.$forceUpdate()
    },
    submit () {
      let query = { ...this.$route.query }
      let selected_options = this.getSelectedOptions.join(this.payload.splitter || ',')
      query[this.payload.designator] = selected_options.length == 0 ? undefined : selected_options
      this.$router.push({ path: this.$route.path, query: query })
    },
    clearFilter () {
      this.selected_options = []
      this.$forceUpdate()
    },
    selectAll () {
      this.options.forEach(option => {
        this.selectOption(option)
      })
    }
  }
}
</script>
<style scoped>
  .filter {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .button {
    margin-right: 10px;
  }
</style>
